var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgWarningTriangle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 32,
  fill: "var(--color-monochrome-black)",
  fillOpacity: 0.2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#warning-triangle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.68 15.633a4.55 4.55 0 0 1 6.31 1.729l11.2 20.096.007.01A6.433 6.433 0 0 1 41.562 47h-19.13a6.426 6.426 0 0 1-5.629-9.523l.003-.007L28.01 17.358a4.576 4.576 0 0 1 1.67-1.725ZM33.6 25.4a1.6 1.6 0 0 0-3.2 0v6.4a1.6 1.6 0 1 0 3.2 0v-6.4ZM32 36.043a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8Z",
  fill: "var(--color-monochrome-white)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "warning-triangle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(16 15)",
  d: "M0 0h32v32H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangle);
export default ForwardRef;